/**
 * Route constants for the application
 * Centralizes all route paths for type-safe navigation
 */
export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  PROPERTY_SEARCH: '/property-search',

  // Protected routes
  DASHBOARD: '/dashboard',
  DASHBOARD_PAYMENT: '/dashboard/payment',
  DASHBOARD_HISTORY: '/dashboard/history',
  DASHBOARD_LEASE: '/dashboard/lease',

  // Admin routes
  ADMIN: '/admin',

  // Auth related
  EMAIL_VERIFICATION: '/email-verification',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];
